import { render, staticRenderFns } from "./Remediation.vue?vue&type=template&id=3a4a900c&scoped=true"
import script from "./Remediation.vue?vue&type=script&lang=js"
export * from "./Remediation.vue?vue&type=script&lang=js"
import style0 from "./Remediation.vue?vue&type=style&index=0&id=3a4a900c&prod&scoped=true&lang=css"
import style1 from "./Remediation.vue?vue&type=style&index=1&id=3a4a900c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4a900c",
  null
  
)

export default component.exports